module.exports = __webpack_public_path__ + "static/media/optimize-rb-products-optimize-tile.6cf9fbd2.png";